import { render, staticRenderFns } from "./index.vue?vue&type=template&id=10f454c3&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./charge.scss?vue&type=style&index=0&id=10f454c3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10f454c3",
  null
  
)

export default component.exports